import { render, staticRenderFns } from "./presentation-set.vue?vue&type=template&id=5ee64a85"
import script from "./presentation-set.vue?vue&type=script&lang=js"
export * from "./presentation-set.vue?vue&type=script&lang=js"
import style0 from "./presentation-set.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports